//Replaces unloaded item images with missing image icon
function missingImgHandler() {
  const images = document.getElementsByClassName('item-image');
  for (let i = 0; i < images.length; i += 1) {
    const image = images[i];
    // console.log('src:', image.getAttribute('src'));
    // console.log('complete:', image.complete);
    // console.log('naturalWidth:', image.naturalWidth);
    if (!image.complete || image.naturalWidth === 0) {
      // console.log('replacing image...')
      const altText = image.getAttribute('alt');
      const placeholder = document.createElement('img');
      placeholder.classList.add('item-image');
      placeholder.classList.add('placeholder');
      placeholder.setAttribute('src', 'https://s3-us-west-1.amazonaws.com/pg-retail-inventory/pg-images/Glasses+Placeholder+Image-2.jpg');
      placeholder.setAttribute('alt', altText);
      placeholder.setAttribute('title', altText);
      image.replaceWith(placeholder);
    }
  }
}


module.exports = missingImgHandler;


// WEBPACK FOOTER //
// ./public/src/missingImgHandler.js